<script lang="ts" module>
  /** Linien-Icons (24×24, Kontur). „fill“ = flächig gefüllt. */
  const ICONS: Record<string, { d: string[]; fill?: boolean }> = {
    library: { d: ["M5 3.5v17M10 3.5v17", "m14.5 4 5 16.5"] },
    setlist: {
      d: ["M3 6h11M3 11h11M3 16h7", "M19.5 17V6.5l-3 .8", "M19.5 17a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"],
    },
    music: {
      d: [
        "M9 18V6l10-2v12",
        "M9 18a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zM19 16a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z",
      ],
    },
    search: { d: ["M18 11a7 7 0 1 1-14 0 7 7 0 0 1 14 0z", "m20 20-3.5-3.5"] },
    plus: { d: ["M12 5v14M5 12h14"] },
    minus: { d: ["M5 12h14"] },
    check: { d: ["m5 12 4.5 4.5L19 7"] },
    close: { d: ["M6 6l12 12M18 6 6 18"] },
    back: { d: ["m15 18-6-6 6-6"] },
    forward: { d: ["m9 18 6-6-6-6"] },
    chevronDown: { d: ["m6 9 6 6 6-6"] },
    more: { d: ["M5 12h.01M12 12h.01M19 12h.01"] },
    prev: { d: ["M6 6v12", "M18 6v12L9 12z"] },
    next: { d: ["M18 6v12", "M6 6v12l9-6z"] },
    play: { d: ["M8 5.5v13l11-6.5z"], fill: true },
    pause: { d: ["M6.5 5h4v14h-4zM13.5 5h4v14h-4z"], fill: true },
    star: { d: ["m12 3 2.6 5.6 6.1.7-4.5 4.2 1.2 6L12 16.6 6.6 19.5l1.2-6-4.5-4.2 6.1-.7z"] },
    starFill: { d: ["m12 3 2.6 5.6 6.1.7-4.5 4.2 1.2 6L12 16.6 6.6 19.5l1.2-6-4.5-4.2 6.1-.7z"], fill: true },
    tag: { d: ["M3 12V4h8l9 9-8 8z", "M7.5 7.5h.01"] },
    share: { d: ["M16 6l-4-4-4 4M12 2v13", "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7"] },
    info: { d: ["M12 8v.01M12 11v6", "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"] },
    trash: { d: ["M4 7h16M10 11v6M14 11v6", "M6 7l1 13h10l1-13M9 7V4h6v3"] },
    leave: { d: ["M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3", "M10 17l-5-5 5-5M5 12h11"] },
    upload: { d: ["M12 16V4M7 9l5-5 5 5", "M5 20h14"] },
    user: { d: ["M20 21a8 8 0 0 0-16 0", "M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0z"] },
    users: {
      d: [
        "M17 21a6 6 0 0 0-12 0M15 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0z",
        "M21 21a5 5 0 0 0-4-4.9M16 3.1a4 4 0 0 1 0 7.8",
      ],
    },
    tablet: {
      d: ["M7 2.5h10a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-15a2 2 0 0 1 2-2z", "M11 18.5h2"],
    },
    pen: { d: ["M4 20l4-1 11-11-3-3L5 16z", "m14 6 3 3"] },
    highlighter: { d: ["m9 15 7-7 3 3-7 7z", "M9 15 6 18h4l2-2", "M4 21h16"] },
    eraser: { d: ["M8 20h12", "m4.5 15.5 9-9a2 2 0 0 1 2.8 0l2.2 2.2a2 2 0 0 1 0 2.8L13 17H7z"] },
    undo: { d: ["M9 14 4 9l5-5", "M4 9h10a6 6 0 0 1 0 12h-3"] },
    jump: { d: ["M7 7h8a4 4 0 0 1 0 8H7", "m10 18-3-3 3-3"] },
    dual: { d: ["M3 4h8v16H3zM13 4h8v16h-8z"] },
    fullscreen: { d: ["M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"] },
    autoscroll: { d: ["M12 4v14", "m6 13 6 6 6-6"] },
    grip: { d: ["M5 9h14M5 15h14"] },
    logout: { d: ["M9 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h3", "M14 17l5-5-5-5M19 12H9"] },
    key: { d: ["M15 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM11 12l9 9M17 18l2-2M15 16l2-2"] },
    refresh: { d: ["M20 12a8 8 0 1 1-2.3-5.7", "M20 4v5h-5"] },
    chart: { d: ["M4 20V10M10 20V4M16 20v-7M22 20H2"] },
    pencilInput: { d: ["M3 21l3-1 12-12-2-2L4 18z", "M14 6l2 2"] },
    bulb: {
      d: [
        "M9 18h6M10 21h4",
        "M12 3a6 6 0 0 0-3.6 10.8c.7.6 1.1 1.3 1.1 2.2h5c0-.9.4-1.6 1.1-2.2A6 6 0 0 0 12 3z",
      ],
    },
    bridge: {
      d: [
        "M6 4h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z",
        "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z",
      ],
    },
    power: { d: ["M12 3v8", "M6.3 6.8a8 8 0 1 0 11.4 0"] },
    sparkle: {
      d: ["M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M18 6l-2.5 2.5M8.5 15.5 6 18"],
    },
  };
</script>

<script lang="ts">
  let { name, size = 22, stroke = 2 }: { name: string; size?: number; stroke?: number } = $props();
  const icon = $derived(ICONS[name] ?? ICONS.music!);
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 24 24"
  fill={icon.fill ? "currentColor" : "none"}
  stroke={icon.fill ? "none" : "currentColor"}
  stroke-width={name === "more" ? stroke + 1.6 : stroke}
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-hidden="true"
>
  {#each icon.d as d (d)}<path {d} />{/each}
</svg>
